import React from 'react';
import Icon from '@ant-design/icons';

const JPaperClipSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / Paper-Clip</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="paperclip"
        stroke="currentColor"
        transform="translate(1.000000, 0.500000)"
      >
        <path
          d="M13.9285714,7.03199518 L7.3434621,13.7203139 C5.66354356,15.426562 2.93985745,15.426562 1.25993891,13.7203139 C-0.419979636,12.0140657 -0.419979636,9.2476909 1.25993891,7.54144275 L7.84504823,0.853124045 C8.96499393,-0.284374694 10.7807846,-0.28437468 11.9007303,0.853124075 C13.020676,1.99062283 13.020676,3.8348727 11.9007304,4.97237147 L5.30845552,11.6606902 C4.74848267,12.2294396 3.8405873,12.2294396 3.28061446,11.6606902 C2.72064161,11.0919408 2.72064161,10.1698158 3.28061446,9.60106646 L9.36413765,3.42947314"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

export const JPaperClip: React.FC<any> = (props) => {
  return <Icon component={JPaperClipSVG} {...props}  aria-hidden={true}/>;
};
